"use client"

import { useQuery } from "@tanstack/react-query"
import { getShopifyRevenueSummaryAction } from "@/server-actions/shopify/revenue-summary"
import type { RevenueSummary, RevenueSummaryQuery } from "@/lib/shopify/revenue-summary"

export function useShopifyRevenueSummaryQuery(query: RevenueSummaryQuery) {
  return useQuery<RevenueSummary>({
    queryKey: ["shopify", "revenue-summary", query],
    queryFn: async () => {
      const result = await getShopifyRevenueSummaryAction(query)
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
